
<template>
<div class="drag">
	<div class="drag-ct">
		<div class="drag-ct-sl" :class="{disabled:disabled, showed: showHistory}">
			<div class="clearfix" v-if="!showHistory">
				<div class="drag-ct-sl-left left">UTC</div>
				<div class="drag-ct-sl-right right">
					<span @click="reverse">反选</span>
					<span @click="reset">重置</span>
				</div>
			</div>
			<div class="drag-ct-sl-tabble">
				<div class="drag-ct-sl-item clearfix">
					<div class="drag-ct-sl-item-t left">星期/时</div>
					<div class="drag-ct-sl-item-i left"
					     v-for="num in hourList"
                         :key="num">{{num}}</div>
				</div>
				<div>
					<div class="drag-ct-sl-item clearfix">
						<div class="left">
							<div v-for="(tabbleList,index1) in tabbleLists" :key="index1">
								<div class="drag-ct-sl-item-t">{{tabbleList.name}}</div>
							</div>
						</div>
						<div class="left"
						     @mousedown="mousedown($event)"
						     @mousemove="mousemove($event)">
							<div v-for="(tabbleList,index1) in tabbleLists"
                                 :key="index1"
							     class="clearfix">
								<div class="drag-ct-sl-item-i-s left"
								     v-for="(item,index2) in tabbleList.list"
                                     :key="index2"
								     :class="{selected:item.selected}"
								     @click="tabSelectedEvent(index1,index2)"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div v-if="disabled" class="disable-mask"></div>
	</div>
</div>
</template>
<script>
import common from '@/utils/common';
export default {
    props: {
        timezone: {
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showHistory: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            tabbleLists: [],
            isMouseDown: false,
            startX: 0,
            startY: 0,
            endX: 0,
            endY: 0,
            mouseMoveInterval: '',
        };
    },
    watch: {
        timezone: {
            handler () {
                this.init();
            },
            immediate: true
        }
    },
    created() {
        this.init();
    },
    mounted() {
        var _this = this;
        _this.setPosition();
    },
    beforeDestroy() {
        window.removeEventListener('mouseup', this.mouseup);
    },
    methods: {
        init() {
            var _this = this;
            this.tabbleListInit();
            this.timezoneInit();
            window.addEventListener('mouseup', this.mouseup);
        },
        //时区初始化
        timezoneInit() {
            if (this.timezone) {
                var arr = this.timezone.split(',');
                var weeks = [];
                var hours = arr.map(function(item, index) {
                    return item.split('#');
                });
                for (var i = 0; i < hours.length; i++) {
                    weeks = weeks.concat(hours[i].splice(0, 1));
                }
                for (var n = 0; n < hours.length; n++) {
                    for (var m = 0; m < hours[n].length; m++) {
                        this.$set(this.tabbleLists[weeks[n] - 1].list[hours[n][m] - 1], 'selected', true);
                    }
                }
            }
        },
        tabbleListInit() {
            var arr = [];
            var arrName = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
            for (var i = 0; i < 7; i++) {
                arr[i] = {};
                arr[i].name = arrName[i];
                arr[i].list = [];
                for (var j = 0; j < 24; j++) {
                    arr[i].list[j] = {};
                    arr[i].list[j].selected = false;
                }
            }
            this.tabbleLists = arr;
        },
        tabSelectedEvent(fisrtIndex, secondIndex) {
            var selected = this.tabbleLists[fisrtIndex].list[secondIndex].selected;
            this.$set(this.tabbleLists[fisrtIndex].list[secondIndex], 'selected', !selected);
        },
        setPosition() {
            var el = document.querySelector('.drag-ct-sl-item-i-s');
            // var firstPosition = common.offset(el);
            var firstPosition = {
                x: el.offsetLeft,
                y: el.offsetTop,
            };
            for (var i = 0; i < this.tabbleLists.length; i++) {
                for (var j = 0; j < this.tabbleLists[i].list.length; j++) {
                    var position = {
                        x: firstPosition.x + j * 20,
                        y: firstPosition.y + 39 * i,
                    };
                    this.$set(this.tabbleLists[i].list[j], 'position', position);
                    // this.$set(this.tabbleLists[i].list[j], 'week', i + 1);
                    this.$set(this.tabbleLists[i].list[j], 'hour', j + 1);
                }
            }
        },
        mousedown(e) {
            this.isMouseDown = true;
            this.setPosition();
            this.startX = e.target.offsetLeft;
            this.startY = e.target.offsetTop;
        },
        mousemove(e) {
            if (!this.isMouseDown) return;
            var _this = this;
            var pageX = e.target.offsetLeft + e.offsetX;
            var pageY = e.target.offsetTop + e.offsetY;
            _this.dragSelectedEvent(_this.startX, _this.startY, pageX, pageY);
        },
        //判断选择区域,xy轴同时大于块的xy轴则设为选中或者取消
        dragSelectedEvent(startX, startY, endX, endY) {
            for (var i = 0; i < this.tabbleLists.length; i++) {
                for (var j = 0; j < this.tabbleLists[i].list.length; j++) {
                    var X = this.tabbleLists[i].list[j].position.x;
                    var Y = this.tabbleLists[i].list[j].position.y;
                    if (endX - startX >= 0) {
                        //右
                        if (endY - startY >= 0) {
                            //下
                            if (X + 20 > startX && X < endX && Y + 39 > startY && Y < endY) {
                                this.$set(this.tabbleLists[i].list[j], 'selected', true);
                            }
                        } else {
                            //上
                            if (X + 20 > startX && X < endX && Y < startY && Y + 39 > endY) {
                                this.$set(this.tabbleLists[i].list[j], 'selected', true);
                            }
                        }
                    } else {
                        //左
                        if (endY - startY >= 0) {
                            //下
                            if (X < startX && X + 20 > endX && Y + 39 > startY && Y < endY) {
                                this.$set(this.tabbleLists[i].list[j], 'selected', true);
                            }
                        } else {
                            //上
                            if (X < startX && X + 20 > endX && Y < startY && Y + 39 > endY) {
                                this.$set(this.tabbleLists[i].list[j], 'selected', true);
                            }
                        }
                    }
                }
            }
        },
        mouseup() {
            this.isMouseDown = false;
            this.getTimeZone();
        },
        getTimeZone() {
            var arr = [];
            var result = [];
            for (var i = 0; i < this.tabbleLists.length; i++) {
                arr[i] = i + 1;
                for (var j = 0; j < this.tabbleLists[i].list.length; j++) {
                    if (this.tabbleLists[i].list[j].selected) {
                        arr[i] += '#' + (j + 1);
                    }
                }
            }
            arr.forEach(function(item) {
                if (item.toString().indexOf('#') > -1) {
                    result.push(item);
                }
            });
            var str = result.join(',');
            this.$emit('timezone', str);
        },
        reverse() {
            for (var i = 0; i < this.tabbleLists.length; i++) {
                for (var j = 0; j < this.tabbleLists[i].list.length; j++) {
                    var selected = this.tabbleLists[i].list[j].selected;
                    this.$set(this.tabbleLists[i].list[j], 'selected', !selected);
                }
            }
            this.getTimeZone();
        },
        reset() {
            for (var i = 0; i < this.tabbleLists.length; i++) {
                for (var j = 0; j < this.tabbleLists[i].list.length; j++) {
                    this.$set(this.tabbleLists[i].list[j], 'selected', false);
                }
            }
            this.getTimeZone();
        },
    },
    computed: {
        hourList() {
            var arr = [];
            var num;
            for (var i = 0; i < 24; i++) {
                num = i + 1;
                if (num < 10) {
                    num = '0' + num;
                }
                arr.push(num);
            }
            return arr;
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently';
/*.drag {*/
/*position: fixed;*/
/*left: 0;*/
/*top: 0;*/
/*width: 100%;*/
/*height: 100%;*/
/*background-color: rgba(0, 0, 0, 0.7);*/
/*z-index: 9;*/
/*}*/

.drag-ct {
    position: relative;
    width: 598px;
    /*height: 560px;*/
    background-color: #fff;
    /*padding: 38px 48px;*/
    /*position: absolute;*/
    /*left: 50%;*/
    /*top: 50%;*/
    //margin-left: -346px;
    //margin-top: -280px;
}

.drag-ct-tit-text {
    font-size: 20px;
    color: #333333;
    line-height: 34px;
}

.drag-ct-tit-input {
    width: 442px;
    height: 34px;
    border: 1px solid $impColor;
    border-radius: $bdRadius;
}

.drag-ct-sl {
    width: 100%;
    height: 390px;
    padding: 17px 13px;
    border: 1px solid $impColor;
    border-radius: $bdRadius;
    margin-top: 8px;
    box-sizing: border-box;
    transition: all 0.5s ease;
    &.disabled {
        filter: grayscale(90%);
        background: #f2f2f2;
        &.showed {
            .drag-ct-sl-item-i-s.selected {
                background: #23c52f;
            }
        }
        
    }
}

.drag-ct-sl-left {
    width: 186px;
    height: 26px;
    line-height: 26px;
    padding-left: 10px;
    border: $border;
    border-radius: $bdRadius;
    color: #666;
}

.drag-ct-sl-right {
    span {
        font-size: 14px;
        color: #237ec5;
        margin-right: 24px;
        line-height: 26px;
        cursor: pointer;
    }
}

.drag-ct-sl-tabble {
    width: 100%;
    border: $border;
    border-radius: $bdRadius;
    margin-top: 8px;
    border-bottom: none;
}

.drag-ct-sl-item {
    /*height: 39px;*/
    font-size: 12px;
    color: #666;
}

.drag-ct-sl-item-i,
.drag-ct-sl-item-i-s {
    width: 20px;
    line-height: 39px;
    border-right: $border;
    border-bottom: $border;
    text-align: center;
    height: 39px;
    user-select: none;
    cursor: pointer;
}

.drag-ct-sl-item-t {
    width: 87px;
    border-right: $border;
    border-bottom: $border;
    line-height: 38px;
    user-select: none;
    padding-left: 0.1rem;
}

.drag-ct-sl-item-i-s:last-of-type,
.drag-ct-sl-item-i:last-of-type {
    border-right: 0;
}

.drag-ct-sl-item-i-s.selected {
    background-color: #e9f9ea;
}
.disable-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: $bdRadius;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/Drag.vue